import React, { useState } from "react";
import ActionItem from "./ActionItem";

const ActionCenter = ({
    title = "Action Center",
    description,
    actions = [],
    initialVisible = 4,
    className = "",
}) => {
    const [showAll, setShowAll] = useState(false);

    const visibleActions = showAll
        ? actions
        : actions.slice(0, initialVisible);

    return (
        <div
            className={`
        bg-cardbg 
        rounded-2xl 
        border border-bordercolor 
        hover:shadow-md 
        shadow-sm 
        p-3 sm:p-4 lg:p-4 
        ${className}
      `}
        >
            <div className="mb-4">
                <h3 className="flex items-center gap-1 text-lg font-bold text-textprimary">
                    <span className="material-symbols-outlined text-[#6366F1]">
                        electric_bolt
                    </span>
                    {title}
                </h3>

                {description && (
                    <p className="text-sm text-textsecondary mt-2 w-[300px]">
                        {description}
                    </p>
                )}
            </div>

            <div className="space-y-3">
                {visibleActions.map((action, index) => (
                    <ActionItem key={index} {...action} />
                ))}
            </div>

            {actions.length > initialVisible && (
                <div className="mt-4 text-center">
                    <button
                        onClick={() => setShowAll(!showAll)}
                        className="text-sm text-[#6366F1] font-medium"
                    >
                        {showAll ? "Show Less" : "View All Actions"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ActionCenter;